import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData } from '../CustomUtils'
import ReportHeading from '../ReportHeading.js'
import ColumnHeadings from '../ColumnHeadings.js'
import { REOPENED_CLAIMS_QUERY } from '../../../graphql.js'
import ResultsGrid from '../ResultsGrid.js'
import ParameterValues from '../ParameterValues.js'
import LargeRowHandler from '../LargeRowHandler.js'
import { currencyFormatter } from '../CustomUtils'
import '../Custom.css'

const REOPENED_CLAIMS = gql(REOPENED_CLAIMS_QUERY)

export default function ReopenedClaimsReport({ location }) {
  console.log('ReopenedClaimsReport rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, REOPENED_CLAIMS, 'reopenedClaimsReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const resultRows = ResultsGrid(results, 0, null, null, null, 10, currencyFormatter(), number => number)
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Asbestos/reopenedClaimsReport/reopened', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto'}} >
          <ReportHeading title={'Reopened Claims Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}